import { parsePhoneNumber as parseAwesomePhoneNumber } from "awesome-phonenumber"

// Simple phone number validation without using google-libphonenumber
export const isValidPhoneNumber = (phone: string): boolean => {
  try {
    return parseAwesomePhoneNumber(phone).valid
  } catch (error) {
    return false
  }
}

export const formatPhoneNumber = (phone: string): string => {
  try {
    const pn = parseAwesomePhoneNumber(phone)
    return pn.valid ? (pn.number?.international ?? phone) : phone
  } catch (error) {
    return phone
  }
}

export const parsePhoneNumberInfo = (
  phone: string
): {
  countryCode: string
  nationalNumber: string
  isValid: boolean
} => {
  try {
    const pn = parseAwesomePhoneNumber(phone)
    return {
      countryCode: pn.valid ? String(pn.countryCode ?? "") : "",
      nationalNumber: pn.valid ? (pn.number?.national ?? phone) : phone,
      isValid: pn.valid
    }
  } catch (error) {
    return {
      countryCode: "",
      nationalNumber: phone,
      isValid: false
    }
  }
}
